import {Component, inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {DatePipe} from "@angular/common";
import {DialogBaseComponent} from "../dialog-base/dialog-base.component";
import {FormatterComponent} from "../../json-formatter/json-formatter.component";
import {EmailAuditService} from "../../../services/email-audit.service";
import {ErrorHandlingService} from "../../../services/error-handling.service";
import {IEmailAuditDetail} from "../../../interfaces/email-audit/IEmailAuditDetail";
import {IEmailAuditTemplateData} from "../../../interfaces/email-audit/IEmailAuditTemplateData";

export interface IEmailAuditDetailDialogData {
  emailAuditId: string;
}

@Component({
  selector: 'app-email-audit-detail',
  standalone: true,
  imports: [
    DialogBaseComponent,
    FormatterComponent,
    DatePipe
  ],
  templateUrl: './email-audit-detail.component.html',
  styleUrl: './email-audit-detail.component.css'
})
export class EmailAuditDetailComponent implements OnInit {
  private dialogData: IEmailAuditDetailDialogData = inject(MAT_DIALOG_DATA);
  private emailAuditService = inject(EmailAuditService);
  private errorHandlingService = inject(ErrorHandlingService);

  public emailAudit: IEmailAuditDetail | null = null;
  public templateData: IEmailAuditTemplateData | null = null;
  public showLoadingSpinner = true;

  ngOnInit() {
    this.emailAuditService.getEmailAudit(this.dialogData.emailAuditId).subscribe({
      next: (emailAuditP) => {
        this.emailAudit = emailAuditP;
        this.templateData = emailAuditP.Data ? JSON.parse(emailAuditP.Data) : null;
        this.showLoadingSpinner = false;
      },
      error: (errorP) => {
        this.showLoadingSpinner = false;
        this.errorHandlingService.displayDialogLevelErrorMessage(errorP);
      }
    });
  }

  // Redirect emails carry their whole message in these fields, so they can be shown as the recipient saw them.
  get isRedirectEmail(): boolean {
    return this.templateData?.Content != null;
  }
}
